import LocalStorage from '../../data/local-storage';

export default class NotificationsModel {
  constructor() {
    this.notifications = [];
    this.isAuthenticated = false;
    this.user = {};
    this.pushSubscription = null;
  }

  loadUserState() {
    const token = LocalStorage.getItem('heliaedu_token');
    const userData = LocalStorage.getItem('heliaedu_user');
    
    if (token && userData) {
      this.isAuthenticated = true;
      this.user = JSON.parse(userData);
      
      const notificationsKey = `heliaedu_user_notifications_${this.user.id}`;
      const pushSubscriptionKey = `heliaedu_user_push_subscription_${this.user.id}`;
      
      this.notifications = LocalStorage.getObject(notificationsKey) || [];
      this.pushSubscription = LocalStorage.getObject(pushSubscriptionKey);
    } else {
      this.isAuthenticated = false;
      this.user = {};
      this.notifications = [];
      this.pushSubscription = null;
    }
  }

  getNotifications() {
    return this.notifications.sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp));
  }

  addNotification(title, message) {
    if (!this.isAuthenticated) return null;
    
    const notification = {
      id: 'notif_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9),
      title: title,
      message: message,
      timestamp: new Date().toISOString()
    };
    
    this.notifications.unshift(notification);
    
    if (this.notifications.length > 50) {
      this.notifications = this.notifications.slice(0, 50);
    }
    
    const notificationsKey = `heliaedu_user_notifications_${this.user.id}`;
    LocalStorage.setObject(notificationsKey, this.notifications);
    
    return notification;
  }

  removeNotification(notificationId) {
    const oldLength = this.notifications.length;
    this.notifications = this.notifications.filter(n => n.id !== notificationId);
    
    if (this.notifications.length < oldLength) {
      const notificationsKey = `heliaedu_user_notifications_${this.user.id}`;
      LocalStorage.setObject(notificationsKey, this.notifications);
      return true;
    }
    return false;
  }

  isPushSubscribed() {
    return !!this.pushSubscription;
  }

  setPushSubscription(subscription) {
    this.pushSubscription = subscription;
    
    if (this.isAuthenticated && this.user.id) {
      const pushSubscriptionKey = `heliaedu_user_push_subscription_${this.user.id}`;
      if (subscription) {
        LocalStorage.setObject(pushSubscriptionKey, subscription);
      } else {
        LocalStorage.removeItem(pushSubscriptionKey);
      }
    }
  }

  getNotificationPermissionStatus() {
    if (!('Notification' in window)) {
      return 'not-supported';
    }
    return Notification.permission;
  }
}